import { MoonIcon, SunIcon } from "@phosphor-icons/react"
import { Button } from "@repo/ui/components/button"
import { useTheme } from "@repo/ui/components/theme-provider"

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Toggle theme"
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
    >
      <MoonIcon className="size-6 dark:hidden" aria-hidden />
      <SunIcon className="hidden size-6 dark:block" aria-hidden />
    </Button>
  )
}
